import { t } from "../../../i18n";
import type { WallInput, WallResult } from "@tasduvar/engine";
import { ReportDrawing, REPORT_SVG } from "../ReportDrawing";
import { PlanView } from "../../drawing/PlanView";
import { Section } from "./common";

export function Drawing({ wall, result }: { wall: WallInput; result: WallResult }): JSX.Element {
  const plan = wall.geometry.mode === "rc-cantilever" && !!wall.geometry.counterforts;
  return (
    <Section id="drawing" title={t("3. Kesit Çizimi")}>
      <ReportDrawing wall={wall} result={result} title={`${wall.name} — ölçülü kesit (m)`} />
      {plan ? (
        <figure>
          <PlanView wall={wall} width={REPORT_SVG.width} height={Math.round(REPORT_SVG.height * 0.6)} className="report-plan" />
          <figcaption>{wall.name} — {t("Payanda plan görünümü")} (m)</figcaption>
        </figure>
      ) : null}
    </Section>
  );
}
export function ForceDiagram({ wall, result }: { wall: WallInput; result: WallResult }): JSX.Element {
  const gov = result.governingSeismic ?? "static";
  return (
    <Section id="forceDiagram" title={t("4. Kuvvet Şeması ve Basınç Diyagramı")}>
      <ReportDrawing wall={wall} result={result} forces caseId="static" title={t("Statik durum — kuvvetler, basınç diyagramı ve taban gerilmesi")} />
      {result.governingSeismic ? <ReportDrawing wall={wall} result={result} forces caseId={gov} title={`Depremli durum (${gov === "seismicUp" ? "1−kv" : "1+kv"}) — kuvvetler`} /> : null}
    </Section>
  );
}
